export function validateCurrency(value) {
    if(value.includes('.')) {
        if(value.split('.')[1].length > 2) return false;
    };

    return true;
}